import { ListConfigs } from "../../../sharedComponent/SearchList/SearchList.types";

export const OUTBOUNDLISTCONFIGS: ListConfigs[] = [
    {
        headerName: 'Customer Name',
        apiFieldName: 'customerName',
        columnWidth: '150',
        type: 'TEXT',
    },
    {
        headerName: 'Tpv Language',
        apiFieldName: 'language',
        columnWidth: '150',
        type: 'TEXT',
    },
    {
        headerName: 'Make Call',
        apiFieldName: 'image',
        columnWidth: '150',
        type: 'IMAGE',
    }

]
